module.exports = __webpack_public_path__ + "img/photo-0060.a8421a32.jpg";